var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "wheel-history-page" }, [
    _c("div", { staticClass: "wheel-history__title" }, [
      _c(
        "a",
        {
          staticClass: "wheel-history__back-link",
          attrs: { href: "#", "aria-label": "返回上一级" },
          on: {
            click: function ($event) {
              $event.preventDefault()
              return _vm.$router.back()
            },
          },
        },
        [
          _c("i", {
            staticClass: "wheel-history__icon icon icon_circle-arrow-right",
          }),
        ]
      ),
      _c("span", [_vm._v("轮盘历史记录")]),
    ]),
    _c("div", { staticClass: "wheel-history__table table" }, [
      !_vm.isLg
        ? _c("div", { staticClass: "table__head" }, [
            _c("div", { staticClass: "table__cell" }, [_vm._v("局号 ID")]),
            _c("div", { staticClass: "table__cell" }, [_vm._v("时间")]),
            _c("div", { staticClass: "table__cell" }, [_vm._v("总积分")]),
            _c("div", { staticClass: "table__cell" }, [_vm._v("玩家")]),
            _c("div", { staticClass: "table__cell" }, [_vm._v("结果")]),
          ])
        : _vm._e(),
      !_vm.isLoading
        ? _c(
            "div",
            { staticClass: "table__scroll scroll scroll_vertical" },
            _vm._l(_vm.historyPageGames, function (game) {
              return _c(
                "ui-game-history-game",
                {
                  key: game.id,
                  staticClass: "table__row",
                  attrs: {
                    id: game.id,
                    "end-at": game.endAt,
                    "total-bank-usd": game.totalBankUsd,
                    "users-count": game.usersCount,
                  },
                  nativeOn: {
                    click: function ($event) {
                      return _vm.$router.push("/wheel/history/" + game.id)
                    },
                  },
                },
                [
                  _c("wheel-history-round-colors", {
                    attrs: { colors: game.colors, "win-color": game.winColor },
                  }),
                ],
                1
              )
            }),
            1
          )
        : _c(
            "div",
            { staticClass: "table__scroll" },
            _vm._l(_vm.preloadGames, function (_, index) {
              return _c("div", {
                key: index,
                attrs: {
                  width: "100%",
                  height: "10.88rem",
                  background: "rgba(36, 44, 84, 0.5)",
                  "border-radius": "1.92rem",
                },
              })
            }),
            0
          ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }